import { environment } from "../../../environments/environment";
import { ElevateBillingReportsComponent } from "../components/elevate-billing-reports/elevate-billing-reports.component";
import { ChartComponent } from "../layout/chart/chart.component";
import { DashboardContainerComponent } from "../layout/dashboard-container/dashboard-container.component";
import { ApiEnvNames, FETCH_METHODS, SearchConfig } from "./api.model";
import { OptionsFetchConfig } from "./common.model";
import { ElevateBillingAmountForAreaChartSchema, ElevateBillingAmountForYearChartSchema, ElevateBillingAreaBillingYearChartSchema, ElevateBillingAttendenceCountDealersChartSchema, ElevateBillingAttendenceCountJobRoleChartChartSchema, ElevateBillingTrendsDealersAndJobRolesChartChartSchema, ElevateBillingTrendsDealersChartSchema, ElevateBillingTrendsJobRoleChartSchema } from "./elevate-billing-dashboard.model";
import { FieldNames } from "./form-fields.model";
import { dynamicComponentSchema, SECTION_TYPE, TabConfig } from "./form.model";

export const getElevateBillingBaseUrl = () => {
    return environment['elevateBilling'];
};

const SectionNames = {
    AreaBillingYear:'areaBillingYear',
    BillingTrendsDealers:'billingTrendsDealer',
    BillingTrendsJobRole:'billingTrendsJobRole',
    BillingTrendsJobRoleAndDealers:'billingTrendsJobRoleAndDealers',
    AttendenceCountDealers:'attendenceCountDealers',
    AttendenceCountJobRole:'attendenceCountJobRole',
    ElevateBillingReport: 'elevateBillingReport',
    BillingAmountForArea:'billingAmountForArea',
    BillingAmountForYear:'billingAmountForYear'
} as const;

export const ElevateBillingTabIds = {
    Report: 'report',
    Dashboard: 'dashboard'
}

const FetchConfig: Record<SECTION_NAMES, SearchConfig> = {
    [SectionNames['AreaBillingYear']]: {
        path: 'billingTrendForArea',
        method: FETCH_METHODS['Get'],
        urlPath: ApiEnvNames['ElevateBilling'],
        body:{
            [FieldNames['Event']]:''
        }
    },
    [SectionNames['BillingTrendsDealers']]: {
        path: 'billingTrendForDealers',
        method: FETCH_METHODS['Get'],
        urlPath: ApiEnvNames['ElevateBilling'],
        body:{
            [FieldNames['Event']]:''
        }
    },
    [SectionNames['BillingTrendsJobRole']]: {
        path: 'billingTrendForJobRoles',
        method: FETCH_METHODS['Get'],
        urlPath: ApiEnvNames['ElevateBilling'],
        body:{
            [FieldNames['Event']]:''
        }
    },
    [SectionNames['BillingAmountForYear']]: {
        path: 'billingAmountForYear',
        method: FETCH_METHODS['Get'],
        urlPath: ApiEnvNames['ElevateBilling'],
        body:{ }
    },
        [SectionNames['BillingAmountForArea']]: {
        path: 'billingAmountForArea',
        method: FETCH_METHODS['Get'],
        urlPath: ApiEnvNames['ElevateBilling'],
        body:{
            [FieldNames['Area']]:''
        }
    },
    [SectionNames['BillingTrendsJobRoleAndDealers']]: {
        path: 'billingTrendForJobRolesAndDealers',
        method: FETCH_METHODS['Get'],
        urlPath: ApiEnvNames['ElevateBilling'],
        body:{
            [FieldNames['Event']]:'',
            [FieldNames['JobRole']]:''
        }
    },
    [SectionNames['AttendenceCountDealers']]: {
        path: 'dealerAttendanceCount',
        method: FETCH_METHODS['Get'],
        urlPath: ApiEnvNames['ElevateBilling'],
        body:{
            [FieldNames['Event']]:''
        }
    },
    [SectionNames['AttendenceCountJobRole']]: {
        path: 'jobAttendanceCount',
        method: FETCH_METHODS['Get'],
        urlPath: ApiEnvNames['ElevateBilling'],
        body:{
            [FieldNames['Event']]:''
        }
    },
    [SectionNames['ElevateBillingReport']]: {
        path: 'billingReportSearch',
        method: FETCH_METHODS['Post'],
        urlPath: ApiEnvNames['ElevateBilling'],
        body:{
            [FieldNames['SpinId']]: 1,
            "jobRole": "SALES MANAGER",
            "areaOrDistrict": "WESTERN AREA",
            "dealerNumber": null,
            "attendance": "Completed",
            "event": "Elevate leaders 2024"
          }
    },
}

type SECTION_NAMES = typeof SectionNames[keyof typeof SectionNames];

export const ElevateBillingTitle = "Elevate Billing";

export const ElevateBillingDynamicOptionSchema: OptionsFetchConfig = {
    fields: [
        { name: FieldNames['Event'], keyValuePair: { fieldLabel: 'EVENT', fieldValue: 'EVENT' } },
        { name: FieldNames['JobRole'], keyValuePair: { fieldLabel: 'JobRole', fieldValue: 'JobRole' } }
    ],
    searchConfig: {
        method: FETCH_METHODS['Get'],
        path: 'jobRolesAndEvents',
    }
}

const ElevateBillingGridSchema: Array<dynamicComponentSchema> = [
    {
    component: ChartComponent,
    type: SECTION_TYPE['Chart'],
    inputs: {
        chartSchema: ElevateBillingAreaBillingYearChartSchema['chartSchema'],
        chartType: ElevateBillingAreaBillingYearChartSchema['chartType'],
        elementId: SectionNames['AreaBillingYear'],
        apiConfig: FetchConfig[SectionNames['AreaBillingYear']],
        filterSchema: ElevateBillingAreaBillingYearChartSchema['filterSchema'],
        exportConfig:ElevateBillingAreaBillingYearChartSchema['exportConfig'],
        infoFields: ElevateBillingAreaBillingYearChartSchema['infoFields']
        }
    },
        {
        component: ChartComponent,
        type: SECTION_TYPE['Chart'],
        inputs: {
            chartSchema: ElevateBillingTrendsDealersChartSchema['chartSchema'],
            chartType: ElevateBillingTrendsDealersChartSchema['chartType'],
            elementId: SectionNames['BillingTrendsDealers'],
            apiConfig: FetchConfig[SectionNames['BillingTrendsDealers']],
            filterSchema: ElevateBillingTrendsDealersChartSchema['filterSchema'],
            exportConfig:ElevateBillingTrendsDealersChartSchema['exportConfig'],
            infoFields: ElevateBillingTrendsDealersChartSchema['infoFields']
            }
    },
    {
        component: ChartComponent,
        type: SECTION_TYPE['Chart'],
        inputs: {
            chartSchema: ElevateBillingTrendsJobRoleChartSchema['chartSchema'],
            chartType: ElevateBillingTrendsJobRoleChartSchema['chartType'],
            elementId: SectionNames['BillingTrendsJobRole'],
            apiConfig: FetchConfig[SectionNames['BillingTrendsJobRole']],
            filterSchema: ElevateBillingTrendsJobRoleChartSchema['filterSchema'],
            exportConfig:ElevateBillingTrendsJobRoleChartSchema['exportConfig'],
            infoFields: ElevateBillingTrendsJobRoleChartSchema['infoFields']
            }
    },
    {
        component: ChartComponent,
        type: SECTION_TYPE['Chart'],
        inputs: {
            chartSchema: ElevateBillingTrendsDealersAndJobRolesChartChartSchema['chartSchema'],
            chartType: ElevateBillingTrendsDealersAndJobRolesChartChartSchema['chartType'],
            elementId: SectionNames['BillingTrendsJobRoleAndDealers'],
            apiConfig: FetchConfig[SectionNames['BillingTrendsJobRoleAndDealers']],
            filterSchema: ElevateBillingTrendsDealersAndJobRolesChartChartSchema['filterSchema'],
            exportConfig:ElevateBillingTrendsDealersAndJobRolesChartChartSchema['exportConfig'],
            infoFields: ElevateBillingTrendsDealersAndJobRolesChartChartSchema['infoFields']
            }
    },
    {
    component: ChartComponent,
    type: SECTION_TYPE['Chart'],
    inputs: {
        chartSchema: ElevateBillingAttendenceCountDealersChartSchema['chartSchema'],
        chartType: ElevateBillingAttendenceCountDealersChartSchema['chartType'],
        elementId: SectionNames['AttendenceCountDealers'],
        apiConfig: FetchConfig[SectionNames['AttendenceCountDealers']],
        filterSchema: ElevateBillingAttendenceCountDealersChartSchema['filterSchema'],
        exportConfig:ElevateBillingAttendenceCountDealersChartSchema['exportConfig'],
        infoFields: ElevateBillingAttendenceCountDealersChartSchema['infoFields']
        }
    },
    {
        component: ChartComponent,
        type: SECTION_TYPE['Chart'],
        inputs: {
            chartSchema: ElevateBillingAttendenceCountJobRoleChartChartSchema['chartSchema'],
            chartType: ElevateBillingAttendenceCountJobRoleChartChartSchema['chartType'],
            elementId: SectionNames['AttendenceCountJobRole'],
            apiConfig: FetchConfig[SectionNames['AttendenceCountJobRole']],
            filterSchema: ElevateBillingAttendenceCountJobRoleChartChartSchema['filterSchema'],
            exportConfig:ElevateBillingAttendenceCountJobRoleChartChartSchema['exportConfig'],
            infoFields: ElevateBillingAttendenceCountJobRoleChartChartSchema['infoFields']
            }
    },
    {
        component: ChartComponent,
        type: SECTION_TYPE['Chart'],
        inputs: {
            chartSchema: ElevateBillingAmountForYearChartSchema['chartSchema'],
            chartType: ElevateBillingAmountForYearChartSchema['chartType'],
            elementId: SectionNames['BillingAmountForYear'],
            apiConfig: FetchConfig[SectionNames['BillingAmountForYear']],
            filterSchema: ElevateBillingAmountForYearChartSchema['filterSchema'],
            exportConfig:ElevateBillingAmountForYearChartSchema['exportConfig'],
            infoFields: ElevateBillingAmountForYearChartSchema['infoFields']
            }
    },
    {
        component: ChartComponent,
        type: SECTION_TYPE['Chart'],
        inputs: {
            chartSchema: ElevateBillingAmountForAreaChartSchema['chartSchema'],
            chartType: ElevateBillingAmountForAreaChartSchema['chartType'],
            elementId: SectionNames['BillingAmountForArea'],
            apiConfig: FetchConfig[SectionNames['BillingAmountForArea']],
            filterSchema: ElevateBillingAmountForAreaChartSchema['filterSchema'],
            exportConfig:ElevateBillingAmountForAreaChartSchema['exportConfig'],
            infoFields: ElevateBillingAmountForAreaChartSchema['infoFields']
            }
    },
]

export const ElevateBillingTabSchema: Array<TabConfig> = [
    {
        label: 'Charts',
        tabId: ElevateBillingTabIds['Dashboard'],
        type: SECTION_TYPE.Dashboard,
        component: DashboardContainerComponent,
        inputs: {
            gridSchema: ElevateBillingGridSchema
        }
    },
    {
    label: 'Reports',
    tabId: ElevateBillingTabIds['Report'],
    type: SECTION_TYPE.FilterWithTable,
    component: ElevateBillingReportsComponent,
    inputs: {
    }
}];